// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cMKWb","content":"styles_content__BYJmR","leftContent":"styles_leftContent__6Mn7U","button":"styles_button__PPKiR"};